import { HYDRATE } from 'next-redux-wrapper';

import { ERROR_NEWS, GET_NEWS, SET_NEWS } from '../actionTypes/news';

const initialState = {
    fetching: false,
    fetchError: null,
    items: [],
    itemsByAlias: [],
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
};

export default function reducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.news };
        case GET_NEWS:
            return { ...state, ...payload };
        case SET_NEWS:
            return { ...state, ...payload };
        case ERROR_NEWS:
            return { ...state, ...payload };
        default:
            return state;
    }
}
